import React, { Component } from "react";
import { Modal, Button, Image } from "react-bootstrap";
import { get, sumBy } from "lodash";
import { getMeetingCardInfoAction } from "../../actions/mom.action";
import { isValidArray } from "../../helper";
import { PATHS } from "../../constant";
import { Link } from "react-router-dom";
import {
  getLocalstorage,
  dateFormat,
  getDayOfTheGivenDate,
  getTimeOfTheGivenDate,
  getAgendaTagsColor
} from "../../helper";
import ChairedBy from "../../assets/created-by.svg";
import MeetingOM from "../../assets/pragati-meeting-om.svg";
import Calendar from "../../assets/add-decision-calendar.svg";
import MeetingModeIcon from "../../assets/meeting-mode-icon.svg";

class PragatiCardInfo extends Component {
  state = {
    isLoading: true,
    cardInfo: null
  };

  async componentDidMount() {
    const response = await this.getCardInfo();
    const { data } = response || {};
    this.setState({
      isLoading: false,
      cardInfo: get(data, "data")
    });
  }

  getCardInfo = () => {
    const { pragatiDetails } = this.props;
    return getMeetingCardInfoAction(
      undefined,
      pragatiDetails && pragatiDetails.id
    );
  };
  truncateWithEllipsis(str, maxLength) {
    if (str.length <= maxLength) {
      return str;
    }
    return str.slice(0, maxLength - 3) + "..."; // Truncate to maxLength-3 and add "..."
  }
  render() {
    const { onClose, pragatiDetails } = this.props;
    const { cardInfo } = this.state;
    const prgatiProject = [];
    const nonPragatiProject = [];
    const pendingWithRmRs = [];
    let meetingOm = get(pragatiDetails, "fileDTOList", []);
    get(cardInfo, "pragati") &&
      get(cardInfo, "pragati").forEach(element => {
        const isProjectExists = prgatiProject.find(pragati => {
          return element.sector === pragati.sector;
        });
        !isProjectExists && prgatiProject.push(element);
      });

    get(cardInfo, "nonPragati") &&
      get(cardInfo, "nonPragati").forEach(element => {
        const isProjectExists = nonPragatiProject.find(proj => {
          return element.sector === proj.sector;
        });
        !isProjectExists && nonPragatiProject.push(element);
      });

    get(cardInfo, "pendingWithRMRS") &&
      get(cardInfo, "pendingWithRMRS").forEach(element => {
        const isProjectExists = pendingWithRmRs.find(proj => {
          return element.issueId === proj.issueId;
        });
        !isProjectExists && pendingWithRmRs.push(element);
      });
      const groupCategory = getLocalstorage("groupCategory");
    return (
      <Modal
        class="agenda-card-info-modal"
        show={true}
        onHide={onClose}
        animation={true}
        size="lg"
      >
        <section className="agenda-card-info-title">
          <Modal.Header closeButton>
            <Modal.Title>Agenda Summary</Modal.Title>
          </Modal.Header>
        </section>
        <section className="card-info-body">
          <section className="card-info-header">
            <div className="agenda-list-title">
              AGENDA ID{" "}
              <span className="agenda-id">
                {groupCategory=="PMG"?<>
                <Link
                  to={{
                    pathname: PATHS.AGENDA_DETAILS,
                    search: `?agendaId=${get(pragatiDetails, "id", "NA")}`,
                    state: {
                      agendaId: pragatiDetails.id
                    }
                  }}
                  style={{color:"#007BFF"}}
                >
                  #{pragatiDetails && pragatiDetails.id}
                </Link>
                </>:<>
                <Link
                  
                  style={{color:"#007BFF"}}
                >
                  #{pragatiDetails && pragatiDetails.id}
                </Link>
                </>}
                
              </span>{" "}
              |{" "}
              {get(pragatiDetails, "projectCount") ? (
                <span className="agenda-total">
                  {get(pragatiDetails, "projectCount")} Project(s){" "}&
                </span>
              ) : <span className="agenda-total">
              0 Project(s){" "}&
               </span>}{" "}
              <span className="agenda-total">
              {get(pragatiDetails, "issueCount")} Issue(s)
              </span>
              {get(cardInfo, "totalProjectCost") ? (
                <span className="agenda-total">
                  {" "}
                  | &#x20B9; {get(cardInfo, "totalProjectCost").toFixed(2)} Cr.
                </span>
              ) : null}
              <h3 className="agenda-name-in-cards">
                {pragatiDetails && pragatiDetails.agendaName}
              </h3>
            </div>
            <div className="agenda-card">
              <div
                className={`${getAgendaTagsColor(
                  pragatiDetails.meetingStatus
                )} ${
                  pragatiDetails.meetingStatus === "DRAFT"
                    ? "draft-agenda-btn"
                    : ""
                } agenda-stage`}
              >
                <div
                  className={`agenda-stage-background ${
                    pragatiDetails.meetingStatus === "DRAFT"
                      ? "draft-agenda-text"
                      : ""
                  }`}
                >
                  {pragatiDetails.meetingStatus}
                </div>
              </div>
            </div>
          </section>
          <div className="flex-style">
            <div className="flex-width d-flex agenda-card-chairedby">
              <span>
                <Image src={Calendar} />
              </span>
              <div>
                <span>
                  <b>When</b>
                  <br />
                  {getDayOfTheGivenDate(pragatiDetails.meetingDate) +
                    ", " +
                    dateFormat(get(pragatiDetails, "meetingDate")) +
                    (pragatiDetails.meetingTimeFrom !== null &&
                    pragatiDetails.meetingTimeFrom !== 0
                      ? ", " +
                        getTimeOfTheGivenDate(pragatiDetails.meetingTimeFrom)
                      : "")}
                </span>
              </div>
            </div>
            <div className="flex-width d-flex agenda-card-chairedby">
              <span>
                <Image src={MeetingModeIcon} />
              </span>
              <div>
                <span>
                  <b>Meeting Mode</b>
                  <br />
                  {pragatiDetails.meetingMode==null?<>NA</>:<>
                          {pragatiDetails.meetingMode.toLowerCase()
                          .replace(/_/g, " ")
                          .replace(/(?: |\b)(\w)/g, function(key, p1) {
                            return key.toUpperCase();
                          })}</>}
                </span>
              </div>
            </div>
          </div>
          <div className="flex-style">
            <div className="flex-width d-flex agenda-card-chairedby">
              <span>
                <Image src={MeetingOM} />
              </span>
              <div>
                <span>
                  <b>Meeting OM</b>
                  <br />
                  <label class="meeting-om-attachment" style={{cursor:meetingOm.length === 0?"auto":"pointer"}}>
                   {meetingOm.length === 0?<>--</>:<>
                    <a
                     className="om_attachment_link"
                     target="_blank"
                     href={meetingOm[0].s3Url}
                    style={{color:"#18499C",fontWeight:600}}
                   >
                   {this.truncateWithEllipsis(meetingOm[0].name.substring(0, meetingOm[0].name.lastIndexOf(".")),32)}
                   </a>
                   <div class="attachment-added-tooltip-om pragati">
                     <div class="project-download-icons" style={{marginBottom:0,marginRight:0}}>
                       <div class="download-icons-pdf">{meetingOm[0].name
                      .substr(meetingOm[0].name.lastIndexOf(".") + 1, meetingOm[0].name.length)
                      .toLowerCase()}</div>
                       <a
                         target="_blank"
                         href={meetingOm[0].s3Url}
                         download={meetingOm[0].s3Url}
                         rel="noopener noreferrer"
                         style={{paddingLeft:6,paddingRight:0,textDecoration:"none"}}
                       >
                         {meetingOm[0].name}
                       </a>
                     </div>
                   </div>
                   </>}
                   
                 
              
             </label>
                  {/* {pragatiDetails && pragatiDetails.meetingType
                    ? pragatiDetails && pragatiDetails.meetingType
                    : "NA"} */}
                </span>
              </div>
            </div>
            <div className="flex-width d-flex agenda-card-chairedby">
              <span>
                <Image src={ChairedBy} />
              </span>
              <div>
                <span>
                  <b>Chaired by</b>
                  <br />
                  {pragatiDetails && pragatiDetails.meetingChairedBy
                    ? pragatiDetails && pragatiDetails.meetingChairedBy
                    : null}
                </span>
              </div>
            </div>
          </div>

          <div>
            {prgatiProject && prgatiProject.length ? (
              <div className="meeting-project-info">
                <b className="">Pragati</b>
                <div className="sector-detail-box">
                  {prgatiProject && prgatiProject.length} SECTOR(S) |{" "}
                  {sumBy(prgatiProject, "projectCount")} PROJECT(S) |{" "}
                  {sumBy(prgatiProject, "issueCount")} ISSUE(S) | &#x20B9;{" "}
                  {sumBy(prgatiProject, "projectCost").toFixed(2)} Crores
                </div>
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Sector Name</th>
                      <th>No. of Issue(s)</th>
                      <th>No. of Project(s)</th>
                      <th>Cost</th>
                    </tr>
                  </thead>
                  <tbody>
                    {prgatiProject.map((project, index) => {
                      return (
                        <tr>
                          <td>{project.sector}</td>
                          <td>{project.issueCount}</td>
                          <td>{project.projectCount}</td>
                          <td>&#x20B9; {project.projectCost.toFixed(2)} Cr.</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : null}
          </div>
          <div>
            {nonPragatiProject && nonPragatiProject.length ? (
              <div className="meeting-project-info">
                <b className="">Non-Pragati</b>
                <div className="sector-detail-box">
                  {nonPragatiProject && nonPragatiProject.length} SECTOR(S) |{" "}
                  {sumBy(nonPragatiProject, "projectCount")} PROJECT(S) |{" "}
                  {sumBy(nonPragatiProject, "issueCount")} ISSUE(S) |{" "}
                  &#x20B9; {sumBy(nonPragatiProject, "projectCost").toFixed(2)}{" "}
                  Crores
                </div>
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Sector Name</th>
                      <th>No. of Project(s)</th>
                      <th>No. of Issue(s)</th> 
                      <th>Cost</th>
                    </tr>
                  </thead>
                  <tbody>
                    {nonPragatiProject.map((project, index) => {
                      return (
                        <tr>
                          <td>{project.sector}</td>
                          <td>{project.projectCount}</td>
                          <td>{project.issueCount}</td>
                          <td>&#x20B9; {project.projectCost.toFixed(2)} Cr.</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : null}
          </div>
          {isValidArray(get(cardInfo, "issueResolved")) ? (
            <div className="agenda-issues-info meeting-project-info">
              <span>
                <b className="">
                  Issues Resolved ({get(cardInfo, "issueResolved").length})
                </b>
                <p className="agenda-projects-list">
                  {get(cardInfo, "issueResolved").map((issue, index) => {
                    return (
                      <Link
                        to={{
                          pathname: PATHS.ISSUE_DETAIL,
                          search: `projectId=${issue.projectId}&issueId=${
                            issue.issueId
                          }`
                        }}
                      >
                        {" "}
                        #{issue.issueId}
                        {index < get(cardInfo, "issueResolved").length - 1
                          ? ","
                          : ""}
                      </Link>
                    );
                  })}
                </p>
              </span>
            </div>
          ) : null}

          {isValidArray(get(cardInfo, "projectClosed")) ? (
            <div className="meeting-pragati-project-info">
              <b className="">Projects Closed</b>
              <div className="agenda-projects-list">
                <b>
                  <span>
                    {get(cardInfo, "projectClosed").length} Project(s)
                  </span>{" "}
                  |{" "}
                  <span>
                    &#8377; {get(cardInfo, "closedProjectsCost").toFixed(2)} Cr.
                  </span>
                </b>
                <br />
                <span>
                  Project(s) :
                  {get(cardInfo, "projectClosed").map((project, index) => {
                    return (
                      <Link
                        to={{
                          pathname: PATHS.PROJECT_DETAILS,
                          search: `projectId=${project}`
                        }}
                      >
                        {" "}
                        #{project}
                        {index < get(cardInfo, "projectClosed").length - 1
                          ? ","
                          : ""}
                      </Link>
                    );
                  })}
                </span>
              </div>
            </div>
          ) : null}

          {isValidArray(get(cardInfo, "pendingWithRMRS")) ? (
            <div className="meeting-pragati-project-info">
              <span>
                <b className="">
                  RM/RS Pending Issues (
                  {pendingWithRmRs && pendingWithRmRs.length})
                </b>
                <p className="sector-box">
                  {pendingWithRmRs &&
                    pendingWithRmRs.length &&
                    pendingWithRmRs.map((project, index) => {
                      return (
                        <Link
                          to={{
                            pathname: PATHS.ISSUE_DETAIL,
                            search: `projectId=${project.projectId}&issueId=${
                              project.issueId
                            }`
                          }}
                        >
                          #{project.issueId}
                          {index < pendingWithRmRs.length - 1 ? ", " : ""}
                        </Link>
                      );
                    })}
                </p>
              </span>
            </div>
          ) : null}

          <div className="agenda-created-on">
           Updated on
            <span>
              {" "}
              {getDayOfTheGivenDate(pragatiDetails.updatedDate) +
                ", " +
                dateFormat(pragatiDetails.updatedDate) +
                ", " +
                getTimeOfTheGivenDate(pragatiDetails.updatedDate)}
            </span>
          </div>
        </section>
      </Modal>
    );
  }
}

export { PragatiCardInfo };
